import footerStyle from '@salesforce/retail-react-app/app/theme/components/project/footer'
import {remCalc} from '../../_utils'

export default {
    ...footerStyle,
    parts: [
        'container',
        'content',
        'subscribe',
        'subscribeField',
        'subscribeButtonContainer',
        'subscribeHeading',
        'subscribeMessage',
        'localeSelector',
        'bottomHalf',
        'horizontalRule',
        'copyright',
        'socialIcons',
    ],
    baseStyle: {
        container: {
            width: 'full',
            background: 'background.brand',
            display: 'flex',
            paddingBlock: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            paddingInline: {base: remCalc(16), md: remCalc(24), lg: remCalc(40), xl: remCalc(260)},
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(24),
        },
        localeSelector: {
            w: '85px',
        },
        copyright: {
            textStyle: ['body-xsmall'],
            color: 'text.inverse',
            mt: remCalc(16),
        },
        policies: {
            textStyle: ['body-xsmall'],
            color: 'text.inverse',
            opacity: '0.7',
        },
        socialIcons: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(40),
        },
        socials: {
            color: 'background.default',
            boxSize: ['iconsSize.large'],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        socialApp: {
            alignItems: 'center',
            gap: remCalc(60),
            justifyContent: 'flex-end',
        },
        appIcons: {
            alignItems: 'center',
            gap: remCalc(12),
        },
        appIcon: {
            width: remCalc(105),
            height: remCalc(31),
        },
        benefitIcons: {
            color: 'background.light-blue',
            boxSize: ['iconsSize.xlarge'],
        },
        iconsBenefitSection: {
            display: 'grid',
            gridTemplateColumns: {
                base: '1fr 1px 1fr',
                lg: '1fr 1px 1fr 1px 1fr 1px 1fr',
            },
            gridTemplateRows: 'auto', // Keep rows auto-sized
            justifyContent: {base: 'center', md: 'space-between'},
            paddingInline: {base: '0', md: remCalc(24), lg: remCalc(50)},
            alignItems: 'center',
            w: '100%',
        },
        benefitText: {
            color: 'background.light-blue',
            textStyle: 'body-large',
            textAlign: 'center',
            display: 'block',
            width: remCalc(124),
        },
        benefitStack: {
            alignItems: 'center',
            gap: remCalc(16),
            textAlign: 'center',
            minHeight: remCalc(120),
        },
        dividerRule: {
            color: 'border.light',
            my: remCalc(20),
        },
        paymentsSection: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(16),
        },
        paymentIcons: {
            w: remCalc(41),
            h: remCalc(27),
            display: 'flex',
            padding: `0 ${remCalc(0.5)}`,
            justifyContent: 'center',
            alignItems: 'center',
        },
        brandCountry: {
            alignItems: 'center',
            gap: remCalc(12),
        },
        countryPayments: {
            alignItems: 'flex-start',
            gap: remCalc(24),
            flexShrink: '0',
        },
        paymentsLegal: {
            w: '100%',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
        },
        socialAppPrivacy: {
            gap: remCalc(40),
        },
        linkColumnContainer: {
            w: '100%',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            paddingTop: {base: 0, lg: remCalc(24)},
        },
        footerBrand: {
            width: remCalc(116.204),
            height: remCalc(36),
        },
        mobileStack: {
            gap: remCalc(40),
            alignItems: 'center',
        },
        mobileLogoCoutry: {
            gap: remCalc(12),
            justifyContent: 'center',
        },
        accordionHeading: {
            color: 'background.light-blue',
            textStyle: ['body-medium'],
        },
        accordionIcon: {
            color: 'background.light-blue',
            boxSize: 'iconsSize.large',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        accordionList: {
            color: 'text.inverse',
            textStyle: ['body-small'],
            opacity: 0.8,
            paddingY: remCalc(16),
        },
        accordionItem: {
            borderColor: 'background.light-blue',
            borderTopWidth: remCalc(0.5),
            paddingInline: '0',
            paddingY: remCalc(18),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        accordionButton: {
            alignItems: 'center',
        },
        hideOnMobile: {display: {base: 'none', lg: 'block'}},
        hideOnDesktop: {display: {base: 'block', lg: 'none'}},
        mobileContainer: {
            paddingInline: {base: '0', md: remCalc(24)},
        },
        cartFooterBrand: {
            display: {base: 'none', lg: 'block'},
        },
        cartBrandLegal: {
            justifyContent: {base: 'center', lg: 'space-between'},
            alignItems: 'center',
            w: '100%',
        },
        copyPositioning: {
            position: {base: 'relative', lg: 'absolute'},
            bottom: {base: 'auto', lg: remCalc(40)},
            right: {base: 'auto', lg: remCalc(255)},
            width: {base: '100%', lg: 'auto'},
            textAlign: 'center',
        },
    },
}
